import { useState } from 'react'

import { useScrollDriver } from '@/hooks/useScrollDriver'

/**
 * Scroll progress, 0 → 1, of the element in `ref` as React state (see
 * `useScrollDriver`), for sections whose markup follows it. Rounded to
 * thousandths so a re-render only happens when it visibly moves.
 */
export function useScrollProgress(ref, measure) {
  const [p, setP] = useState(0)
  useScrollDriver(ref, measure, (value) => setP(Math.round(value * 1000) / 1000))
  return p
}
